var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7164_14951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2868 4.81702C28.9113 4.81702 29.4884 5.14977 29.8013 5.6902L55.468 50.0236C55.7814 50.565 55.782 51.2325 55.4695 51.7745C55.1571 52.3164 54.579 52.6504 53.9535 52.6504H2.62012C1.99453 52.6504 1.41652 52.3164 1.10405 51.7745C0.791579 51.2325 0.792178 50.565 1.10562 50.0236L26.7723 5.6902C27.0852 5.14977 27.6623 4.81702 28.2868 4.81702ZM5.6554 49.1504H50.9182L28.2868 10.0598L5.6554 49.1504Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2868 39.817C29.2533 39.817 30.0368 40.6005 30.0368 41.567V42.7337C30.0368 43.7002 29.2533 44.4837 28.2868 44.4837C27.3203 44.4837 26.5368 43.7002 26.5368 42.7337V41.567C26.5368 40.6005 27.3203 39.817 28.2868 39.817Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2853 21.151C29.2518 21.1502 30.036 21.933 30.0368 22.8995L30.0465 34.5656C30.0473 35.5321 29.2644 36.3162 28.2979 36.317C27.3314 36.3178 26.5473 35.535 26.5465 34.5685L26.5368 22.9024C26.536 21.9359 27.3188 21.1518 28.2853 21.151Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7164_14951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    transform: "translate(0.286133 0.733521)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.0b70c1d6.svg";
export { ForwardRef as ReactComponent };